import { CampaignStatus } from "@/types/campaign/campaign-status/campaign-status";
import styled, { DefaultTheme } from "styled-components";

const getStatusColor = (status: CampaignStatus) => {
    switch (status) {
        case 'pending_claim':
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.common?.green; 
        case 'completed':
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.common?.green;
        case 'expired':
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.text?.paragraphs;
        case 'inCourse':
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.text?.paragraphs; 
        case 'comingUp':
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.theme?.warning;
        case 'incourseWinning':
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.theme?.warning;
        case 'incourseLoosing':
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.text?.paragraphs;
        default:
            return (props: { theme: DefaultTheme }) => props.theme?.colors?.common?.green;
    }
};

export const ContainerObjetive = styled.div`
    display: flex;
    padding: 0;
    align-items: flex-start;
    width: 100%;
    height: 96px;
    border-radius: 16px;
    overflow: hidden;
    background-color: ${({ theme }) => theme?.colors?.theme?.contentBg};
    box-shadow: -4px 4px 10px rgba(0, 0, 0, 0.3);
`;

export const MediaCardIcon = styled.img`
    width: 96px;
    height: 96px;
    object-fit: cover;
    margin: 0px;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
    padding: 12px 16px;
    align-self: stretch;
    flex: 1 0 0;
`;

export const Title = styled.div`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    align-self: stretch;

    overflow: hidden;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    text-overflow: ellipsis;
    font-family: 'Red Hat Display', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;

export const LeaderBoardPlace = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    align-self: stretch;
`;

export const BoardText = styled.div<{ $status: CampaignStatus}>`
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    color: ${props => {
    const colorFunction = getStatusColor(props.$status);
    return typeof colorFunction === 'function' ? colorFunction(props) : colorFunction;
}};
`;

export const HeartIcon = styled.img`
    width: 12px;
    height: 12px;
`;

export const LikesText = styled.div<{ $status: CampaignStatus}>`
    color: ${props => {
    const colorFunction = getStatusColor(props.$status);
    return typeof colorFunction === 'function' ? colorFunction(props) : colorFunction;
    }};
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: 'Red Hat Display', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
`;